import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import nbrApi from '../../../services/nbrApi';
import { useNavigate, useParams } from 'react-router-dom';

// Validation schema
const validationSchema = Yup.object().shape({
    taskName: Yup.string().max(60, 'Task Name must be at most 60 characters').required('Task Name is required'),
    taskDescription: Yup.string().max(100, 'Task Description must be at most 100 characters').required('Task Description is required'),
    taskSubType: Yup.string().required('Task Sub Type is required'),
    status: Yup.string().required('Status is required')
});

let property = JSON.parse(localStorage.getItem('selectedProperty')) || null
const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
];
const TaskForm = (props) => {
    const { id } = useParams()
    const navigate = useNavigate()
    // State declarations
    const [taskSubTypes, setTaskSubTypes] = useState([]);
    const [statuses, setStatuses] = useState(statusOptions);

    // Formik form handling
    const formik = useFormik({
        initialValues: {
            taskName: '',
            taskDescription: '',
            taskSubType: '',
            status: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            // console.log(values)
            props.handleAction(values)
        },
    });

    // Fetch task sub types by property ID and task type ID
    const getTaskSubTypes = async () => {
        if (!formik.values.taskSubType) {
            setTaskSubTypes([]);
        }
        try {
            const response = await nbrApi.get(`/gettasksubtypesbyp?properties_id=${formik.values.property}`);

            const data = response.data;
            setTaskSubTypes(data?.map(e => ({
                ...e,
                value: e?.tt_id,
                label: e?.task_subtype_name
            })));

        } catch (error) {
            console.error('Error fetching data:', error.message);
        }
    };

    // Other useEffect hooks and functions remain unchanged...

    useEffect(() => {
        if (formik.values.property) {
            // Fetch initial data
            getTaskSubTypes();
        }
    }, [formik.values.property]);

    useEffect(() => {
        if (property) {
            formik.setFieldValue('property', property?.value)
        }
    }, [property])

    // default preselect if user comes for EDIT
    useEffect(() => {
        if (props?.selectedData && !formik.values.taskName && !formik.values.taskDescription) {
            let selectedData = props.selectedData
            
            console.log(selectedData)

            // setTaskSubTypes(props.taskData)
            formik.setFieldValue('taskName', selectedData?.item_task_name)
            formik.setFieldValue('taskDescription', selectedData?.item_task_description || '')
            formik.setFieldValue('taskSubType', parseInt(props?.taskType))
            formik.setFieldValue('status', 'active')
        }
        // if (props?.taskData?.length > 0  && !formik.values.taskName && !formik.values.taskDescription) {

        // }
        // if (props?.taskData?.length > 0 && taskSubTypes?.length > 0 && !formik.values.taskSubType) {
        //     let findData = taskSubTypes?.find(e => e?.label === selectedData?.subtype_name)
        //     formik.setFieldValue('taskSubType', parseInt(findData?.value))
        //     // console.log("Selected Task Sub Type Value:", selectedData?.task_id);
        //     // console.log("Task Sub Types:", taskSubTypes?.find(option => option.value === selectedData?.task_id));
        // }
    }, [formik, props.selectedData, props?.taskType])

    // render
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="taskName">Task Name (max 60 characters):</label>
                    <input
                        type="text"
                        id="taskName"
                        name="taskName"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.taskName}
                    />
                    {formik.errors.taskName && formik.touched.taskName && (
                        <div className="text-danger mt-3">{formik.errors.taskName}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="taskDescription">Task Description (max 100 characters):</label>
                    <textarea
                        id="taskDescription"
                        name="taskDescription"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.taskDescription}
                    />
                    {formik.errors.taskDescription && formik.touched.taskDescription && (
                        <div className="text-danger mt-3">{formik.errors.taskDescription}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="taskSubType">Task Sub Type:</label>
                    <Select
                        className="form-control p-0"
                        options={taskSubTypes}
                        id="taskSubType"
                        onChange={(selectedOption) => formik.setFieldValue("taskSubType", selectedOption.value)}
                        value={taskSubTypes?.find(option => option.value === formik.values.taskSubType) || {}}
                    />
                    {formik.errors.taskSubType && formik.touched.taskSubType && (
                        <div className="text-danger mt-3">{formik.errors.taskSubType}</div>
                    )}
                </div>
                <div className="form-group mb-3">
                    <label className="m-1 text-black" htmlFor="status">Status:</label>
                    <Select
                        className="form-control p-0"
                        options={statuses}
                        id="status"
                        onChange={(selectedOption) => formik.setFieldValue("status", selectedOption.value)}
                        value={statuses?.find(option => option.value === formik.values.status) || {}}
                    />
                    {formik.errors.status && formik.touched.status && (
                        <div className="text-danger mt-3">{formik.errors.status}</div>
                    )}
                </div>
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    );
};

export default TaskForm;
